<template>
  <div class="g-header show">
    <div class="logo-box">
      <a :href="logoLink"><img class="logo" :src="logo" /></a>
    </div>
    <div class="center-box">
      <nav-list :nav-list="showNavList" :actived="actived" :is-editing="isEditing" :show-create="isShowCreate && showCreate" :hasNewFeat="hasNewFeat" :userInfo="userInfo"/>
    </div>
    <div class="right-box">
      <div class="message-box js-message-box">
        <div class="g-header-message">
          <qrcode />
          <msg />
          <a class="msg-icon" href="/v2/dist/help.html" target="_blank" title="帮助中心" rel="opener">
            <i class="iconfont icon-33"></i>
          </a>
        </div>
      </div>
      <account :data="userInfo"/>
    </div>
    <platform-dialog v-if="showPlatform && !isSp" :sign="true" @disagree="clearAuth" @agree="showPlatform = false" :show-tip="showTip" :id="id" :account-type="1" :protocol-name="protocolName" :protocol-url="protocolUrl"></platform-dialog>
    <common-broadcast v-if="isCommonBroadcastShow" :id="pushId" :title="pushTitle" :content="pushHtml" :type="pushType" :images="pushImgList" :videos="pushVideos" @close-broadcast="closeBroadcast"></common-broadcast>
  </div>
</template>
<script>
  import vauth from 'common/v-auth.js';
  import cookie from 'common/cookie.js';
  import WebFlowWrapper from '@mi/web-flow-wrapper'
  import {getAccountInfo, getAccountStatus, getMsgList, readMsg, queryAuth} from './api.js';
  import Qrcode from './comps/qrcode.vue';
  import Msg from './comps/msg.vue';
  import NavList from './comps/nav.vue';
  import Account from './comps/account.vue';
  import PlatformDialog from '../platform-dialog.vue';
  import CommonBroadcast from '../common-broadcast.vue';
  import {AccountInfo} from 'common/axios.js';
  const PROTOCOL_URL = {
    EMI_AD_SERVICE_PROTOCOL_V1: 'https://fe-static.cnbj1.mi-fds.com/fe-static/html/emi_platform_protocol_gz.html',
    EMI_AD_SERVICE_PROTOCOL_V1_SZ: 'https://fe-static.cnbj1.mi-fds.com/fe-static/html/emi_platform_protocol_sz_new.html',
    Message_V3_SZ: 'https://fe-static.cnbj1.mi-fds.com/fe-static/html/emi_protocol_sz_new.html',
    Message_V3: 'https://fe-static.cnbj1.mi-fds.com/fe-static/html/emi_protocol_gz.html',
    Message_V3_NJ: 'https://fe-static.cnbj1.mi-fds.com/fe-static/html/emi_protocol_nj.html',
    EMI_AD_SERVICE_PROTOCOL_V1_NJ: 'https://fe-static.cnbj1.mi-fds.com/fe-static/html/emi_platform_protocol_nj.html',
  };
  const EMI4_LINK = {
    plan: '/emi-frontend/adManagement',
    data: '/emi-frontend/admin/dataAnalysis'
  };
  const EMI3_LINK = {
    plan: '/v2/dist/plan.html',
    data: '/v2/dist/data.html'
  };
  const getEmi4Storage = () => {
    const sessionCustomerId = sessionStorage.getItem('customerId');
    let sessionIsEmi4 = localStorage.getItem('formEmi4');
    if (sessionIsEmi4) {
      let info = JSON.parse(sessionIsEmi4);
      if (info.expireTime < Date.now()) {
        localStorage.removeItem('formEmi4');
        return false;
      }
      let emi4Group = sessionIsEmi4 ? JSON.parse(sessionIsEmi4).value : [];
      if (emi4Group?.length && emi4Group.includes(sessionCustomerId)) {
        return true;
      }
    }
    return false;
  }
  export default {
    name: 'com-header',
    props: {
      logo: {
        type: String,
        default: '//assets.cnbj1.mi-fds.com/assets/emi/logo_n.png'
      },
      logoLink: {
        type: String,
        default: '/'
      },
      navList: {
        type: Array,
        default: () => {
          return [
            {name: '首页', url: '/emi-frontend/admin/index', key: 'headerHomepage'},
            {name: '推广', url: '/v2/dist/plan.html', key: 'headerAd', value: 'plan', hasEmi4: true},
            {name: '数据', url: '/v2/dist/data.html', key: 'headerDataReport', value: 'data', hasEmi4: true},
            {name: '工具', url: '/v2/dist/tools.html', key: 'headerToolbox'},
            {name: '素材', url: '/emi-frontend/admin/material', key: 'headerAssets', bage: 'NEW', target: '_blank'},
            {name: '财务', url: '/v2/dist/finance.html', key: 'headerFinance'},
            {name: '学堂', url: '/v2/dist/course.html', key: 'headerCourse', target: '_blank'},
          ];
        }
      },
      isAuth: Boolean,
      actived: String,
      showCreate: {
        type: Boolean,
        default: true
      }
    },
    data() {
      const account = AccountInfo.getAccountFromSys();
      return {
        aiService: null,
        userInfo: null,
        currentUser: null,
        showPlatform: false,
        isEditing: 0,
        isSp: false,
        accountId: '',
        isCommonBroadcastShow: false,
        pushId: null,
        pushType: 1,
        pushTitle: '',
        pushHtml: '',
        pushImgList: [],
        pushVideos: [],
        protocolUrl: '',
        protocolName: '',
        customerId: account.customerId,
        showTip: false,
        hasNewFeat: false
      };
    },
    computed: {
      id() {
        return this.customerId || this.accountId;
      },
      isShowCreate() { 
        return !/(group|creative)\/list\/\d+/ig.test(window.location.href);
      },
      isShowCreateBtn () {
        if (this.userInfo?.currentUser?.adCreateStatus != 'NORMAL') return false;
        return true;
      },
      showNavList() {
        let toEmi4 = getEmi4Storage();
        let navList = [];
        if (this.navList.find(it => it.key === 'headerAd') && this.hasNewFeat) {
          const emi4 = {name: '资产', url: '/emi-frontend/capital', key: 'headerCapital', target: '_blank'};
          const nav = structuredClone(this.navList);
          nav.splice(this.navList.findIndex(it => it.key === 'headerToolbox'), 0, emi4);
          navList = nav;
        } else {
          navList = this.navList;
        };
        navList = navList.map((item) => {
          if (item.hasEmi4 && (toEmi4 || !this.isShowCreateBtn)) {
            item.url = EMI4_LINK[item.value];
          } else if (item.hasEmi4) {
            item.url = EMI3_LINK[item.value];
          };
          if (item.key === 'headerHomepage') {
            item.url = '/emi-frontend/admin/index?id=' + this.id;
          }
          return item;
          
        });
        return navList;
      }
    },
    components: {
      Qrcode,
      Msg,
      Account,
      NavList,
      PlatformDialog,
      CommonBroadcast
    },
    created() {
      window.GLOBAL = {};
      this.initCookie();
      this.getAccount();
      this.getPrevilege();
    },
    mounted() {
      vauth.getAuth();
      const item = this.navList.find(item => {
        return item.key === this.actived
      })
      // 底层组件或页面有改this.navList的情况，所以要对item.url进行还原处理
      const reg = /^\/.*\.html/
      const biz = item?.url.match(reg)?.[0]
      this.aiService = new WebFlowWrapper({
        biz: biz,
        brand: true,
        debug: true,
      })
    },
    methods: {
      initCookie() {
        if (this.$route && this.$route.params) {
          if (this.$route.params.subAccountId) {
            const {subAccountId, subAccountType} = this.$route.params;
            cookie.deleteItem('customerId');
            cookie.setItem('customerId', `${subAccountId}${subAccountType}`, null, '/');
            cookie.setItem('customerId', `${subAccountId}${subAccountType}`, null, '/lego');
          } else if (this.$route.params.customerId) {
            cookie.deleteItem('customerId');
            let customerId = this.$route.params.customerId;
            cookie.setItem('customerId', customerId, null, '/');
            cookie.setItem('customerId', customerId, null, '/lego');
          }
        }
      },
      async getPrevilege() {
        let data = await queryAuth('emi4');
        if (data && data.length) {
          this.hasNewFeat = true;
        }
      },
      async getAccount() {
        const userInfo = await getAccountInfo();
        const {isEditing} = await getAccountStatus();
        this.isEditing = isEditing;
        userInfo.accounts[0].isEditing = isEditing;
        this.userInfo = userInfo;
        this.currentUser = userInfo.currentUser;
        this.accountId = this.userInfo.currentUser.accountId;
        const c = cookie.getItem('customerId');
        if (!c) {
          cookie.setItem('customerId', this.currentUser.customerId, null, '/');
          cookie.setItem('customerId', this.currentUser.customerId, null, '/lego');
        }
        //处理各种协议
        //贷款
        let protocols = this.currentUser.protocolFlags || [];
        let platform = protocols.filter(it => {
          return it.needPop;
        })[0];
        if (platform && platform.needPop) {
          this.protocolUrl = PROTOCOL_URL[platform.protocolName];
          this.protocolName = platform.protocolName;
          this.showPlatform = true;
          this.showTip = [13, 5].includes(this.currentUser.oldContractType) && [16, 17].includes(this.currentUser.contractType);
        }

        window.GLOBAL.userInfo = userInfo.currentUser;
        window.GLOBAL.currentAccount = userInfo.accounts[0];

        let current = userInfo.accounts.find(it => it.customerId === this.currentUser.customerId);
        this.currentUser.companyName = current.subAccountType === 2 ? current.subAccountName : current.accountName;
        if (this.currentUser && !this.currentUser.audited && window.location.href.indexOf('assets.html') != -1) {
          this.$message.error('账户状态为审核通过时，才可进入EMI创意中心');
          setTimeout(() => {
            window.location.href = '/v2/dist/tools2.html#!/tools/quality/' + this.currentUser.customerId;
          }, 1000);
        }
        this.getBroadcast();
      },
      async closeBroadcast() {
        let data = {
          announcementStatus: 2,
          notificationRequestList: [{
            id: this.pushId,
            categoryId: 1
          }]
        };
        this.isCommonBroadcastShow = false;
        await readMsg(data);
      },
      clearAuth() {
        vauth.clearAuth();
      },
      async getBroadcast() {
        const params = {
          categoryId: 1,
          type: 2,
          page: 1,
          status: 1,
          pageSize: 1,
        }
        let result = await getMsgList(params);
        if (result && result.records && result.records.length > 0) {
          let data = result.records[0];
          let content = JSON.parse(data.content || '{}');
          this.isCommonBroadcastShow = true;
          this.pushId = data.id;
          this.pushType = data.pushType;
          this.pushTitle = data.title;
          this.pushHtml = content.text;
          this.pushImgList = content.pic || [];
          this.pushVideos = content.video || [];
        }
      }
    }
  }
</script>
<style lang="scss">
  @use './header.scss';
  @use './dialog.scss';
</style>